import React, { useContext } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Paper,
  Grid,
} from "@mui/material";

import modulo from "../../../assets/Modulo.svg";
import { RecurringBookingContext } from "../Context/RecurringBookingContextWrapper";

interface RecurringBookingModalProps {
  open: boolean;
  onClose: () => void;
}

const RecurringBookingModal: React.FC<RecurringBookingModalProps> = ({
  open,
  onClose,
}) => {
  const context = useContext(RecurringBookingContext);

  const prestazioni = context?.confermaPianoTerapiaBody?.prestazioni ?? [];

  console.log(context?.importoListino);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      {/* Immagine in alto */}
      <Grid
        container
        sx={{
          width: "100%",
          height: "190px",
          backgroundColor: "#8EBEE6",
          display: "flex",
          justifyContent: "end",
          justifyItems: "end",
        }}
      >
        <Grid item sx={{ height: "auto" }}>
          <img src={modulo} alt="" />
        </Grid>
      </Grid>

      <DialogContent sx={{ p: 4 }}>
        {/* Titolo */}
        <Typography
          variant="h6"
          gutterBottom
          sx={{ color: "#01579B", fontWeight: 600 }}
        >
          Importo Totale
        </Typography>

        {/* Box 1 - Totali */}
        <Paper variant="outlined" sx={{ backgroundColor: "#f5f5f5", p: 2 }}>
          <Typography fontWeight={600} color="#01579B">
            Tot. a carico Paziente
          </Typography>
          <Typography mb={1}>{context?.importoTotale} €</Typography>

          <Typography fontWeight={600} color="#01579B">
            Tot. a carico Ente
          </Typography>
          <Typography mb={1}>00,00 €</Typography>

          <Typography fontWeight={600} color="#01579B">
            Tot. Importo Totale
          </Typography>
          <Typography>{context?.importoTotale} €</Typography>
        </Paper>

        {prestazioni?.map((e: any, index: number) => {
          const data = context?.importoListino?.prestazioni?.[0] ?? null;

          return (
            <React.Fragment key={index}>
              <Typography fontWeight={600} paddingTop={2} gutterBottom>
                {data ? data.prestazione?.[index]?.descrizione : ""}
              </Typography>

              <Paper
                variant="outlined"
                sx={{ backgroundColor: "#f5f5f5", p: 2 }}
              >
                <Typography fontWeight={600} color="#01579B">
                  a Carico del Paziente
                </Typography>
                <Typography mb={1}>
                  {data?.prestazione?.[index]?.impCaricoPaziente ?? ""} €
                </Typography>

                <Typography fontWeight={600} color="#01579B">
                  a Carico dell'Ente
                </Typography>
                <Typography mb={1}>
                  {data?.prestazione?.[index]?.impCaricoEnte ?? ""} €
                </Typography>

                <Typography fontWeight={600} color="#01579B">
                  Importo di Listino
                </Typography>
                <Typography>
                  {data?.prestazione?.[index]?.impListino ?? ""} €
                </Typography>
              </Paper>
            </React.Fragment>
          );
        })}
      </DialogContent>

      {/* Pulsante Chiudi */}
      <DialogActions sx={{ pr: 4, pb: 3 }}>
        <Button variant="contained" onClick={onClose} color="primary">
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecurringBookingModal;
